import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  all: {
    id: "common.action.all",
    defaultMessage: "Все",
  },
  back: {
    id: "common.action.back",
    defaultMessage: "Назад",
  },
  cancel: {
    id: "common.action.cancel",
    defaultMessage: "Отменить",
  },
  continue: {
    id: "common.action.continue",
    defaultMessage: "Продолжить",
  },
  globalError: {
    id: "global-error",
    defaultMessage: "Ой, что-то пошло не так(",
  },
  mandatoryField: {
    id: "mandatory-field",
    defaultMessage: "Поле обязательно",
  },
  ok: {
    id: "common.action.ok",
    defaultMessage: "Хорошо",
  },
  or: {
    id: "common.text.or",
    defaultMessage: "или",
  },
  saveChanges: {
    id: "common.action.saveChanges",
    defaultMessage: "Сохранить изменения",
  },
  success: {
    id: "common.status.success",
    defaultMessage: "Успешно",
  },
  today: {
    id: "common.date.today",
    defaultMessage: "Сегодня",
  },
});
